import ResizableScene from "../core/ResizableScene";

export default class Overlay extends Phaser.GameObjects.Image {
    scene: ResizableScene;

    constructor(scene: ResizableScene, texture = "whiteSquare", frame?: string | number, alpha = 0.8) {
        super(scene, 0, 0, texture, frame);
        this.setAlpha(alpha);
        this.tint = 0x000000;
        this.setInteractive();
        this.resize(this.scene.viewport);
    }

    resize(viewport?: Phaser.GameObjects.Image | Phaser.GameObjects.Zone | Phaser.GameObjects.Image): void {
        viewport = viewport ?? this.scene.viewport;
        this.setSize(viewport.displayWidth, viewport.displayHeight);
        this.setDisplaySize(this.width, this.height);
        this.scene.alignIn.Center(this, viewport);
    }

    static create(scene: ResizableScene, alpha = 0.8): Overlay {
        return new Overlay(scene, "whiteSquare", undefined, alpha);
    }
}
